<template>
  <v-container id="cargo-edit" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              {{
              id
              ? $i18n.t("Edit Cargo - ") + cargo.clientName
              : $i18n.t("Create Cargo")
              }}
            </div>
            <v-col cols="12" md="6">
              <toggle-button
                v-if="cargo.corpType == 2"
                v-model="cargo.forCustomer"
                :labels="{ checked: 'Retail', unchecked: 'Client' }"
                lg
                :height="30"
                :width="cargo.forCustomer ? 100 : 110"
                :font-size="20"
              />
            </v-col>
          </template>

          <v-form id="form">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="3">
                  <z-client-select
                    v-if="cargo.corpType == 2"
                    :diabled="true"
                    v-model="cargo.client"
                    withSelf
                    @change="cargo.fareTariff = null"
                  />
                  <z-vendor-select
                    v-if="cargo.corpType == 1"
                    :diabled="true"
                    v-model="cargo.corp_id"
                    withSelf
                    @change="cargo.fareTariff = null"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <z-material-type-auto-fill v-model="cargo.material" />
                </v-col>
                <v-col cols="12" md="3">
                  <z-vehicle-type-select
                    :label="$i18n.t('Truck Type')"
                    class="purple-input"
                    v-model="cargo.truckType"
                    clearable
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox :label="$i18n.t('Part Load')" v-model="cargo.partLoad" />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field type="number" :label="$i18n.t('Weight')" v-model="cargo.weight" />
                </v-col>
                <v-col cols="12" md="3">
                  <z-date-picker :label="$i18n.t('Pickup Date')" v-model="cargo.tentativeDate" />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field :label="$i18n.t('Packaging')" v-model="cargo.packaging" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="2">
                  <span>Source</span>
                </v-col>

                <v-col cols="12" md="4">
                  <z-address-autofill :label="$i18n.t('Source Address')" v-model="cargo.src" />
                </v-col>

                <v-col cols="12" md="3">
                  <z-country-select v-model="cargo.src.country"></z-country-select>
                </v-col>

                <v-col cols="12" md="3">
                  <z-city-select
                    class="purple-input"
                    v-model="cargo.src.city"
                    :state="cargo.src.state"
                    :country="cargo.src.country"
                  ></z-city-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="2">
                  <span>Destination</span>
                </v-col>

                <v-col cols="12" md="4">
                  <z-address-autofill :label="$i18n.t('Destination Address')" v-model="cargo.dst" />
                </v-col>
                <v-col cols="12" md="3">
                  <z-country-select v-model="cargo.dst.country"></z-country-select>
                </v-col>
                <v-col cols="12" md="3">
                  <z-city-select
                    class="purple-input"
                    v-model="cargo.dst.city"
                    :state="cargo.dst.state"
                    :country="cargo.dst.country"
                  ></z-city-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="2">
                  <div>{{ $i18n.t("Load Conact Person") }}</div>
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field :label="$i18n.t('Name')" v-model="cargo.src.contactName" />
                </v-col>

                <v-col cols="12" md="1">
                  <z-country-select
                    :label="$i18n.t('Code')"
                    v-model="cargo.src.countryCode"
                    isd
                    hideName
                    hideFlag
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    :label="$i18n.t('Phone')"
                    v-model="cargo.src.contactPhone"
                    type="number"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="2">
                  <div>{{ $i18n.t("Unload Conact Person") }}</div>
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field :label="$i18n.t('Name')" v-model="cargo.dst.contactName" />
                </v-col>

                <v-col cols="12" md="1">
                  <z-country-select
                    :label="$i18n.t('Code')"
                    v-model="cargo.dst.countryCode"
                    isd
                    hideName
                    hideFlag
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    :label="$i18n.t('Phone')"
                    v-model="cargo.dst.contactPhone"
                    type="number"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="2">
                  <span>Billing Detail</span>
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field :label="$i18n.t('Name')" v-model="cargo.invBranch.name" />
                </v-col>

                <v-col cols="12" md="1">
                  <v-text-field :label="$i18n.t('GSTIN')" v-model="cargo.invBranch.gstin" />
                </v-col>
                <v-col cols="12" md="3">
                  <z-country-select v-model="cargo.invBranch.address.country" />
                </v-col>

                <v-col cols="12" md="3">
                  <z-state-select
                    v-model="cargo.invBranch.address.state"
                    :country="cargo.invBranch.address.country"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="12">
                  <v-card>
                    <v-list-item-content calss="px-3">
                      <v-row>
                        <v-col cols="12" md="4" class="mx-3">
                          <h3>{{ $i18n.t("Load Assistance") }}</h3>
                        </v-col>
                        <v-spacer />
                        <v-col clos="12" md="6">
                          <v-btn
                            @click="cargo.loadAsst = newItem(cargo.loadAsst)"
                            small
                            style="width:60px;float:right;"
                            color="light-blue"
                            text
                          >
                            <v-icon>mdi-plus</v-icon>
                            <h3>{{ $i18n.t("Add") }}</h3>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-simple-table dense style="padding: 10px">
                      <tbody>
                        <tr v-for="(item, index) in cargo.loadAsst" :key="'item' + index">
                          <td>
                            <v-text-field v-model="item.type" :label="$i18n.t('Type')" />
                          </td>
                          <td>
                            <v-text-field
                              v-model="item.units"
                              :label="$i18n.t('Units')"
                              type="number"
                            />
                          </td>
                          <td>
                            <v-text-field v-model="item.details" :label="$i18n.t('Details')" />
                          </td>
                          <td>
                            <v-btn
                              class="float-right"
                              color="error"
                              small
                              fab
                              text
                              dark
                              @click="remove(cargo.loadAsst, index)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        <v-spacer></v-spacer>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="12">
                  <v-card>
                    <v-list-item-content calss="px-3">
                      <v-row>
                        <v-col cols="12" md="4" class="mx-3">
                          <h3>{{ $i18n.t("Unload Assistance") }}</h3>
                        </v-col>
                        <v-spacer />
                        <v-col clos="12" md="6">
                          <v-btn
                            @click="
                              cargo.unloadAsst = newItem(cargo.unloadAsst)
                            "
                            small
                            style="width:60px;float:right;"
                            color="light-blue"
                            text
                          >
                            <v-icon>mdi-plus</v-icon>
                            <h3>{{ $i18n.t("Add") }}</h3>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-simple-table dense style="padding: 10px">
                      <tbody>
                        <tr v-for="(item, index) in cargo.unloadAsst" :key="'item' + index">
                          <td>
                            <v-text-field v-model="item.type" :label="$i18n.t('Type')" />
                          </td>
                          <td>
                            <v-text-field
                              v-model="item.units"
                              :label="$i18n.t('Units')"
                              type="number"
                            />
                          </td>
                          <td>
                            <v-text-field v-model="item.details" :label="$i18n.t('Details')" />
                          </td>
                          <td>
                            <v-btn
                              class="float-right"
                              color="error"
                              small
                              fab
                              text
                              dark
                              @click="remove(cargo.unloadAsst, index)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        <v-spacer></v-spacer>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </v-col>
              </v-row>

              <!-- <v-row> -->
              <v-card class="my-0">
                <v-card-title class="subtitle-1">
                  {{ $i18n.t("Rate") }}
                  <v-spacer />
                  <v-col cols="12" md="1">
                    <z-cargo-rate-select
                      multiple
                      fab
                      text
                      class="purple-input"
                      :client="cargo.client"
                      :vendor="cargo.corp_id"
                      :vehicleType="cargo.vehicleType"
                      @select="onRateSelect"
                    >
                      <v-btn small fab text>
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </z-cargo-rate-select>
                  </v-col>
                </v-card-title>
                <v-card-text class="py-0">
                  <v-row>
                    <v-col cols="12" md="3" sm="3" v-if="cargo.tariffStructure">
                      <span>
                        <b>
                          {{
                          cargo.tariffStructure.name
                          ? cargo.tariffStructure.name
                          : cargo.tariffStructure._id
                          }}
                        </b>
                      </span>
                    </v-col>
                    <v-spacer />
                    <v-col cols="12" md="3" sm="3" v-if="cargo.fare" class="text-right">
                      <span>
                        <b>
                          {{
                          cargo.fare.currency + " " + cargo.fare.total
                          }}
                        </b>
                      </span>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-divider></v-divider>
              </v-card>
              <!-- </v-row> -->
              <v-row class="mr-2 mt-2">
                <v-btn color="secondary" small fab text dark :to="'/cargo'">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <v-spacer />
                <v-btn v-if="!id" color="info" @click="showQuoteModel = true" :loading="loading">
                  <h3>{{ $i18n.t("SAve As Quotation") }}</h3>
                </v-btn>
                <v-btn color="success" class="mr-0" @click="save()" :loading="loading">
                  <h3>{{ $i18n.t("Save") }}</h3>
                </v-btn>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>

    <v-dialog v-model="showQuoteModel" width="500">
      <v-card>
        <v-card-text>
          <v-row v-if="cargo">
            <v-col cols="12" md="6">
              <v-text-field v-model="cargo.wishPrice" :label="$i18n.t('Wish Price')" type="number" />
            </v-col>
            <v-col cols="12" md="6" class="text-right">
              <v-btn @click="saveQuote()">Submit Quote</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  showQuoteModel = false;
  cargo = {
    client: "",
    src: { country: "", state: "", city: "", addrLine: "" },
    dst: { country: "", state: "", city: "", addrLine: "" },
    invBranch: { address: {} },
    loadAsst: [],
    unloadAsst: [],
  };
  id = null;
  wightTypes = [
    { value: "9", name: "Above 28 MT" },
    { value: "16", name: "Above 40 MT" },
    { value: "11", name: "Do Not Know" },
    { value: "1016", name: "Upto 12 MT" },
    { value: "5", name: "Upto 15 MT" },
    { value: "6", name: "Upto 20 MT" },
    { value: "7", name: "Upto 25 MT" },
    { value: "8", name: "Upto 28 MT" },
    { value: "2", name: "Upto 5 MT" },
    { value: "3", name: "Upto 7 MT" },
    { value: "4", name: "Upto 9 MT" },
  ];

  get loading() {
    return common.loading;
  }

  async getNewCargo() {
    try {
      this.cargo = await doGet("/api/cargo/new");
    } catch (e) {
      common.setError(e.message);
    }
  }

  async saveQuote() {
    if (!this.cargo.wishPrice) {
      common.setError("Provide you wish price.");
      return false;
    }
    try {
      common.setLoading(true);
      const response = await doPost("/api/quot/create", this.cargo);
      common.setLoading(false);
      common.showMessage("Cargo Quotation Request Saved.");
      this.get(response._id);
      this.showQuoteModel = false;
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async onRateSelect(rate) {
    if (rate) {
      this.cargo.tariffStructure = rate.tariffStructure;
      this.cargo.vehicleType = rate.tariffStructure.vehicleType;
      common.setLoading(true);
      try {
        this.cargo.fare = await doPost("/api/cargo/calc/fare", this.cargo);
        common.setLoading(false);
      } catch (e) {
        common.setError(e);
        common.setLoading(false);
      }
    }
  }

  async save() {
    try {
      common.setLoading(true);
      let url = "/api/cargo/save";
      if (this.id) {
        url = "/api/cargo/update/get";
      }
      const response = await doPost(url, this.cargo);
      common.showMessage("Saved Successfully");
      if (!this.id) this.$router.push("/cargo/" + response._id);
      this.get(response._id);
      common.setLoading(false);
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      const response = await doGet("/api/cargo/" + id + "/detail");
      if (!response.invBranch) response.invBranch = { address: {} };
      if (!response.invBranch.address) response.invBranch.address = {};
      if (!response.loadAsst) response.loadAsst = [];
      if (!response.unloadAsst) response.unloadAsst = [];
      this.cargo = response;
      this.id = this.cargo._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    } else {
      this.getNewCargo();
    }
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({});
    return itemList;
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
